import { createSetPropMutation, createClearPropMutation } from '@/store/utils';
import * as types from '@/store/centralizedIssues/mutationTypes';

export default {
  [types.SET_OPEN_DETAILED_ISSUES_POPUP]: createSetPropMutation('openDetailedIssuePopupOnStart'),
  [types.CLEAR_OPEN_DETAILED_ISSUES_POPUP]: createClearPropMutation('openDetailedIssuePopupOnStart'),
  [types.SET_ISSUES_FOR_PROJECT]: createSetPropMutation('centralizedIssuesListForProject', []),
  [types.CLEAR_ISSUES_FOR_PROJECT]: createClearPropMutation('centralizedIssuesListForProject', []),
  [types.CLEAR_ISSUE_DETAILS_FOR_CENTRALIZED_VIEW]: createClearPropMutation('detailedIssueForCentralizedView', {}),
  [types.SET_ISSUE_DETAILS_FOR_CENTRALIZED_VIEW]: createSetPropMutation('detailedIssueForCentralizedView', {}),
  [types.SET_ISSUES_LIST_LOADING]: createSetPropMutation('centralizedIssuesListLoading', false),
  [types.SET_DASHBOARD_ISSUES_LIST_LOADING]: createSetPropMutation('dashboardIssuesListLoading', false),
  [types.SET_PROJECT_ISSUES_LIST_LOADING]: createSetPropMutation('projectIssuesListLoading', false),
  [types.SET_CENTRALIZED_ISSUES]: createSetPropMutation('centralizedIssues', []),
  [types.CLEAR_CENTRALIZED_ISSUES]: createClearPropMutation('centralizedIssues', []),
  [types.SET_CENTRALIZED_ISSUES_FOR_DASHBOARD]: createSetPropMutation('centralizedIssuesForDashboard', []),
  [types.CLEAR_CENTRALIZED_ISSUES_FOR_DASHBOARD]: createClearPropMutation('centralizedIssuesForDashboard', []),
  [types.SET_CENTRALIZED_ISSUES_FOR_PROJECT_DETAILS]: createSetPropMutation('centralizedIssuesForProjectDetails', []),
  [types.CLEAR_CENTRALIZED_ISSUES_FOR_PROJECT_DETAILS]: createClearPropMutation('centralizedIssuesForProjectDetails', []),
  [types.CLEAR_CENTRALIZED_ISSUES_LIST_OPTIONS]: createClearPropMutation('centralizedIssuesListOptions'),
  [types.SET_ISSUES_RUNNING_INTERVAL]: createSetPropMutation('issuesRunningInterval', false),
  [types.SET_ISSUES_PROGRESS]: createSetPropMutation('issuesProgress', 0),
  [types.CLEAR_ISSUES_PROGRESS]: createClearPropMutation('issuesProgress', 0),
  [types.SET_ISSUES_REF_ID]: createSetPropMutation('issuesRefId'),
  [types.CLEAR_ISSUES_REF_ID]: createClearPropMutation('issuesRefId'),
  [types.SET_DASHBOARD_ISSUES_RUNNING_INTERVAL]: createSetPropMutation('dashboardIssuesRunningInterval', false),
  [types.SET_DASHBOARD_ISSUES_PROGRESS]: createSetPropMutation('dashboardIssuesProgress', 0),
  [types.CLEAR_DASHBOARD_ISSUES_PROGRESS]: createClearPropMutation('dashboardIssuesProgress', 0),
  [types.SET_DASHBOARD_ISSUES_REF_ID]: createSetPropMutation('dashboardIssuesRefId'),
  [types.CLEAR_DASHBOARD_ISSUES_REF_ID]: createClearPropMutation('dashboardIssuesRefId'),
  [types.SET_PROJECT_ISSUES_RUNNING_INTERVAL]: createSetPropMutation('projectIssuesRunningInterval', false),
  [types.SET_PROJECT_ISSUES_PROGRESS]: createSetPropMutation('projectIssuesProgress', 0),
  [types.CLEAR_PROJECT_ISSUES_PROGRESS]: createClearPropMutation('projectIssuesProgress', 0),
  [types.SET_PROJECT_ISSUES_REF_ID]: createSetPropMutation('projectIssuesRefId'),
  [types.CLEAR_PROJECT_ISSUES_REF_ID]: createClearPropMutation('projectIssuesRefId'),
  [types.SET_CENTRALIZED_ISSUES_LIST_OPTIONS](state, options = {}) {
    state.centralizedIssuesListOptions = {
      ...(state.centralizedIssuesListOptions || {}),
      ...options,
    };
  },
};
